import { Channel, Topic } from "../constants/index.js";
import { useCallback, useEffect } from "react";
import { MessageBrokerUtils } from "../utils/index.js";
import { RealityCheckActionCreators } from "../redux/action-creators/index.js";
import { useDispatch } from "react-redux";

export const useSportSessionDetails = () => {
  const dispatch = useDispatch();

  const handleSportSessionDetails = useCallback(
    sportSessionDetails => {
      dispatch(
        RealityCheckActionCreators.setSportSessionDetails(sportSessionDetails)
      );
    },
    [dispatch]
  );

  useEffect(() => {
    const handleSportSessionDetailsSubscription = MessageBrokerUtils.subscribe({
      channel: Channel.SESSION,
      topic: Topic.sportSessionDetails,
      callback: handleSportSessionDetails
    });

    return () => {
      handleSportSessionDetailsSubscription?.unsubscribe();
    };
  }, [handleSportSessionDetails]);
};
